import axios from 'axios';


const API_URL = process.env.VUE_APP_ZHULIA_BASE_URL;

class AgentService {
	async getAgentProfileAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		//console.log("headers | ", headers)
		try {
			const response = await axios.get(API_URL + '/Agent/Me', {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getRetailCenterProfileAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		//console.log("headers | ", headers)
		try {
			const response = await axios.get(API_URL + '/Agent/RetailCentre', {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getDeliveryPickupPointsAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		//console.log("headers | ", headers)

		try {
			const response = await axios.get(
				API_URL +
					`/DistributionCentres/PickupPoints?ZoneId=${request_data.ZoneId}&Limit=-1`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllDistributionCentersAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		//console.log("headers | ", headers)

		try {
			const response = await axios.get(
				API_URL + `/DistributionCentres?Limit=-1`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getInventoryBalByDistCenterAsync(authToken, locationId) {
		let headers = {
			Authorization: `${authToken}`,
		};
		//console.log("headers | ", headers)

		try {
			const response = await axios.get(
				API_URL + `/Inventory/Location/${locationId}/Inventory`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getDeliveryWindowsAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		//console.log("headers | ", headers)

		try {
			const response = await axios.get(API_URL + `/DeliveryWindow?Limit=-1`, {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getProductGroupsAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		//console.log("headers | ", headers)

		try {
			const response = await axios.get(API_URL + `/Products/Groups?Limit=-1`, {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getProductCategoriesAsync(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		//console.log("headers | ", headers)

		try {
			const response = await axios.get(
				API_URL + `/Products/Groups/${id}/Categories?Limit=-1`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addCategoryToShopAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		//console.log("headers | ", headers)

		try {
			const response = await axios.post(
				API_URL + `/Clients/${clientId}/ShopCategory`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAgentInventoryAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("headers in getAgentInventoryAsync | ", headers)
		try {
			const response = await axios.post(
				API_URL + '/Clients/Inventory',
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllProductsAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("headers in getAllProductsAsync| ", headers)
		try {
			const response = await axios.get(API_URL + '/Agent/Products?Limit=-1', {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllProductByIdAsync(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("headers in getAllProductsAsync| ", headers)
		try {
			const response = await axios.get(API_URL + `/Products/${id}`, {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getSystemProductsAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("headers in getSystemProductsAsync| ", headers)
		try {
			const response = await axios.get(API_URL + '/Products?Limit=-1', {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAgentCustomersAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(API_URL + '/Agent/Customers', {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAgentUsersAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(API_URL + '/Agent/Users', {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllManufacturersAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + '/Products/Manufacturers?Limit=-1',
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllSuppliersAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + '/Products/Suppliers?Limit=-1',
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllProductAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(API_URL + `/Products`, {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllCategoriesAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + '/Products/Categories?Limit=-1',
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getSubCategoriesByCategoryIdAsync(authToken, categoryId) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/Products/Categories/${categoryId}/SubCategories?Limit=-1`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAgentAllOrderRequestsAsync(authToken, clientId) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/Inventory/Client/${clientId}/Requests?Limit=-1`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAgentAllPreOrderRequestsAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + '/Inventory/Preorders/SearchAndSort',
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addSubCustomer(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(API_URL + '/Customers', request_data, {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getClientUsersRequestsAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + '/Users/SearchAndSort',
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllRegionAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + '/Locations/Regions?Limit=-1',
				{ headers: headers }
			);

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllSubRegionByIdAsync(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/Locations/Regions/${id}/Districts`,
				{ headers: headers }
			);

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllCommunitiesByIdAsync(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/Locations/Districts/${id}/Communities`,
				{ headers: headers }
			);

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllSubRegionAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(API_URL + '/Locations/Districts?Limit=-1', {
				headers: headers,
			});

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getPoultryAsync(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/Customers/${id}/PoultryBatch`,
				{ headers: headers }
			);

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getDistrictByIdAsync(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/Locations/Regions/${id}/Districts?Limit=-1`,
				{ headers: headers }
			);

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getTownByIdAsync(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/Locations/Districts/${id}/Communities?Limit=-1`,
				{ headers: headers }
			);

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getProductInventoryAsync(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(API_URL + `/Products/${id}/Inventory`, {
				headers: headers,
			});

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getPreOrderProductsAsync(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(API_URL + `/PreorderCampaign/${id}`, {
				headers: headers,
			});

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getTopProductsAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + '/Reports/Summary/Preorder',
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addPoultyAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Customers/${request_data.id}/PoultryBatch`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getZoneOrdersAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + '/Inventory/DistributionCentre/Aggregate',
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async generatePurcharseOrderAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + '/Clients/PurchaseOrder/Generate',
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async generateWaybillOrderAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + '/Clients/Waybill/Generate',
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getPurchasedOrderAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + '/Clients/Supplier/Aggregate',
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getWaybillOrderAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + '/Clients/DistributionCentre/Aggregate',
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addBusinessInfoAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.patch(
				API_URL + `/Clients/${clientId}/BusinessOwner`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addCompanyInfoAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.patch(
				API_URL + `/Clients/${clientId}/BusinessCompany`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addNewRegionAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Locations/Regions`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addNewSubRegionAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Locations/Regions/${request_data.id}/Districts`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addCommunityAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Locations/Districts/${request_data.id}/Communities`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateRegionAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.put(
				API_URL + `/Locations/Regions/${request_data.id}`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async canFulfillProductAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.patch(
				API_URL +
					`/PreorderCampaign/${request_data.campaignId}/PreorderFulfillment`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getPreOrdersProductsAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + '/PreorderCampaign/Preorders/SearchAndSort',
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getSalesReportAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + '/Reports/Metrics/Preorder/Revenue',
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getPreOrderCampaignsAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(API_URL + '/PreorderCampaign?Limit=-1', {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllGroupsAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(API_URL + '/Products/Groups?Limit=-1', {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getOverallReportAsync(authToken, clientId, requestData) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Clients/${clientId}/Dashboard/Overview`,
				requestData,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getSupplierDetailsAsync(authToken, Id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(API_URL + `/Products/Supplier/${Id}`, {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getToTalRequestAsync(authToken, clientId) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/Inventory/Client/${clientId}/Requests`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addNewStockAsync(authToken, retailCentreId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/RetailCentres/${retailCentreId}/Deliveries`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addPreOrderProductAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL +
					`/PreorderCampaign/${request_data.id}/PreorderCampaignProduct`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addNewProductAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(API_URL + `/Products`, request_data, {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addNewGroupAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Products/Groups`,
				request_data,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateGroupAsync(authToken, groupId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.put(
				API_URL + `/Products/Groups/${groupId}`,
				request_data,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addCategoryAsync(authToken, groupId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Products/Groups/${groupId}/Categories`,
				request_data,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addProductSupplierAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Products/Suppliers`,
				request_data,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addProductManufacturerAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Products/Manufacturers`,
				request_data,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateProductAsync(authToken, final_request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.put(
				API_URL + `/Products/${final_request_data.productId}`,
				final_request_data.request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async updateCategoryAsync(authToken, categoryId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.put(
				API_URL + `/Products/Categories/${categoryId}`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async updateProductSupplierAsync(authToken, supplierId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.put(
				API_URL + `/Products/Suppliers/${supplierId}`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async getBackOrdersDataAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(API_URL + `/BackOrders?Limit=-1`, {
				headers: headers,
			});
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async updateProductManufacturerAsync(authToken, manufactureId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.put(
				API_URL + `/Products/Manufacturers/${manufactureId}`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async setProductPriceAsync(authToken, final_request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.patch(
				API_URL + `/Products/${final_request_data.ProductId}`,
				final_request_data.request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async deleteProductAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.patch(
				API_URL + `/Products/${request_data.id}`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async addInventoryRequestAsync(authToken, retailCentreId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/RetailCentres/${retailCentreId}/InventoryRequests`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addNewClientUserAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(API_URL + `/Users`, request_data, {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateClientUserAsync(authToken, userId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.put(
				API_URL + `/Users/${userId}`,
				request_data,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async changeUserPasswordAsync(authToken, userId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.patch(
				API_URL + `/Users/${userId}`,
				request_data,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getInventoryReportAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Reports/${clientId}/InventoryReport/${request_data.id}`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getWaybillReportAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("request_data | ", request_data)
		try {
			const response = await axios.post(
				API_URL + `/Clients/Waybill/SearchAndSort`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getPurchasedOrderReportAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("request_data | ", request_data)
		try {
			const response = await axios.post(
				API_URL + `/Clients/PurchaseOrder/ListFilterAndSort`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAgentPurchasedOrderAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/PurchaseOrders/SearchAndSort`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getClientProductsAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Products/SearchAndSort`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addSupplierAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Products/Suppliers`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addManufacturerAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Products/Manufacturers`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getDailySalesAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Reports/${clientId}/DailySales`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getMonthlySalesAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Reports/${clientId}/MonthlySales`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getFinanceOverviewAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Clients/${clientId}/FinanceOverview`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getSalesReportsAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Reports/${clientId}/SalesReportCard`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getDailySalesSummaryAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Reports/${clientId}/DailySales`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addStockToWarehouseAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Warehouses/${request_data.id}/Deliveries`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addBackOrderAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(API_URL + `/BackOrders`, request_data, {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addNewCustomerAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/RetailCentres`,
				request_data,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getBackOrderByIdAsync(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/BackOrders/${id}?backOrderId=${id}`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllWarehousesAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(API_URL + `/Warehouses`, {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getWareHouseDeliveriesAsync(authToken, locationId) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(
				API_URL + `/Inventory/Deliveries?Limit=-1&LocationId=${locationId}`,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getWareHousTransferDataAsync(authToken, locationId) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			let url = '';

			if (locationId) {
				url =
					API_URL +
					`/Inventory/Requests?Limit=-1&RequestType=1&SourceLocationId=${locationId}`;
			} else {
				url = API_URL + `/Inventory/Requests?Limit=-1&RequestType=1`;
			}
			const response = await axios.get(url, { headers: headers });
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllInventoryProductsAsync(authToken, locationId) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(
				API_URL + `/Inventory/Location/${locationId}/Inventory`,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getMonthlySalesSummaryAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Reports/${clientId}/MonthlySales`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateBackOrderLinesAsync(
		authToken,
		backOrderId,
		backOrderLineId,
		request_data
	) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = axios.patch(
				API_URL + `/BackOrders/${backOrderId}/BackOrderLine/${backOrderLineId}`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateNewCustomerAsync(authToken, customerId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = axios.put(
				API_URL + `/RetailCentres/${customerId}`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateCustomerStatusAsync(authToken, customerId, isActive) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = axios.patch(
				API_URL + `/RetailCentres/${customerId}?IsActive=${isActive}`,
				{},
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateCustomerTierAsync(authToken, customerId, tier) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = axios.patch(
				API_URL + `/RetailCentres/${customerId}/Tier?Tier=${tier}`,
				{},
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateBackOrderAsync(authToken, backOrderId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = axios.patch(
				API_URL + `/BackOrders/${backOrderId}/Status`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateStockAdjustmentAsync(authToken, stockId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = axios.patch(
				API_URL + `/Inventory/Adjustment/${stockId}`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			// console.log("error 1 | ", error)
			return error.response;
		}
	}

	async addNewStockAdjustmentAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = axios.post(
				API_URL + `/Inventory/Adjustments`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllRetailersAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(API_URL + `/RetailCentres?Limit=-1`, {
				headers: headers,
			});
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllCommunitiesAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/Locations/Communities?Limit=-1`,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getAllStockAdjustmentAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/Inventory/Adjustments?Limit=-1`,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getPayoutTransactionHistoryAsync(authToken, clientId) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/Clients/${clientId}/PaymentRequest`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getOverviewTopProductsAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Reports/${clientId}/ProductSales`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getSalesByLocationAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Reports/${clientId}/LocationSales`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getSalesByCategoryAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Reports/${clientId}/ProductCategorySales`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getSalesByCustomerAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Reports/${clientId}/CustomerSales`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getClientBankDetailAsync(authToken, clientId) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/Clients/${clientId}/BankDetails`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getRetailerOrdersAsync(authToken, locationId) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL +
					`/Inventory/Requests?Limit=-1&DestinationLocationId=${locationId}`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateClientBankDetailAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.put(
				API_URL + `/Clients/${clientId}/BankDetails`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async financeRequestAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.patch(
				API_URL + `/Clients/${clientId}/CheckoutStatus`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async createClientBankDetailAsync(authToken, clientId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Clients/${clientId}/BankDetails`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getSalesAgentsAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Agent/SalesAgent`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addOnboardingInfoAsync(authToken, retailCentreId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/RetailCentres/${retailCentreId}/Details`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async addInventoryTransferAsync(
		authToken,
		destinationLocationId,
		request_data
	) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL +
					`/DistributionCentres/${destinationLocationId}/InventoryRequests`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async confirmNewOrderAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL +
					`/Inventory/Requests/${request_data.inventoryRequestId}/Confirmations`,
				request_data.reasons,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async declineNewOrderAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.patch(
				API_URL + `/Inventory/Requests/${request_data.inventoryRequestId}`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async getRetailCenterDetailsAsync(authToken, retailCentreId) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/RetailCentres/${retailCentreId}`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async getRetailShopCategoryAsync(authToken, retailCentreId) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL + `/RetailCentres/${retailCentreId}/ShopCategory`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async getRetailCustomersAsync(authToken, payload) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.get(
				API_URL +
					`/Customers?Limit=-1&RetailCentreId=${payload?.sortBy?.retailCentreId}`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async getRetailOrdersAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.post(
				API_URL + `/Inventory/Orders`,
				request_data,
				{
					headers: headers,
				}
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async addProductDetailsAsync(authToken, retailCentreId, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.patch(
				API_URL + `/RetailCentres/${retailCentreId}/ProductEstimate`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async setProductStatusAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		// console.log("API_URL | ", API_URL + '/Customers')
		try {
			const response = await axios.patch(
				API_URL + `/Products/${request_data.ProductId}`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async uploadProductImageAsync(authToken, request_data) {
		// console.log("request_data | ", request_data)
		let headers = {
			Authorization: `${authToken}`,
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
		};
		try {
			const response = await axios.patch(
				API_URL +
					`/Products/${request_data.ProductId}/Image?IsPrimary=${request_data.IsPrimary}`,
				request_data.formData,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			console.log('error | ', error.response);
			return error.response;
		}
	}

	async deleteProductImageAsync(authToken, request_data) {
		// console.log("request_data | ", request_data)
		let headers = {
			Authorization: `${authToken}`,
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
		};
		try {
			const response = await axios.delete(
				API_URL +
					`/Products/${request_data.ProductId}/Image?ImageId=${request_data.ImageId}`,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			// console.log('error | ', error.response);
			return error.response;
		}
	}

	async addProductInventoryAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/Products/${request_data.ProductId}/Inventory`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			// console.log('error | ', error.response);
			return error.response;
		}
	}

	async updateProductInventoryAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.patch(
				API_URL + `/Products/${request_data.ProductId}/Inventory`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			// console.log('error | ', error.response);
			return error.response;
		}
	}
}

export default new AgentService();
